import { WelcomeComponent } from "./feature/home/welcome/welcome.component";
import { MyProfileComponent } from "./feature/my-profile/my-profile.component";
import { HomePageResolver } from "./shared/resolve/homepage.resolve";
import { ExtraOptions, Routes } from "@angular/router";

export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "welcome", component: WelcomeComponent },
  {
    path: "home",
    loadChildren: () =>
      import("./feature/home/module/home-routing.module").then((m) => m.home_routes),
      resolve: {
        profile: HomePageResolver
      }
  },
  {
    path: "vehicle",
    loadChildren: () =>
      import("./feature/my-vehicle/module/my-vehicle-routing.module").then(
        (m) => m.vehicle_routes
      ),
    data: { title: "vehicle" },
  },

  {
    path: "alert",
    loadChildren: () =>
      import("./feature/alert/module/alert-routing.module").then((m) => m.alert_routes),
    data: { title: "alert" },
  },
  {
    path: "tools-service",
    loadChildren: () =>
      import(
        "./feature/tools-and-service/module/tools-and-service.routing.module"
      ).then((m) => m.tool_routes),
    data: { title: "tools-service" },
  },
  {
    path: "maintenance-appointments",
    loadChildren: () =>
      import(
        "./feature/maintenance-and-appointments/module/maintenance-and-appointments.routing.module"
      ).then((m) => m.maintenance_and_appointments_routes),
    data: { title: "maintenance-appointments" },
  },
  {
    path: "contracts",
    loadChildren: () =>
      import("./feature/contracts/module/contracts.routing.module").then(
        (m) => m.contracts_routes
      ),
    data: { title: "contracts" },
  },
  {
    path: "administration",
    loadChildren: () =>
      import("./feature/administration/module/administration.routing.module").then(
        (m) => m.administration_routes
      ),
    data: { title: "administration" },
  },
  {
    path: "manage-profiles",
    loadChildren: () =>
      import("./feature/manage-profiles/module/manage-profiles.routing.module").then(
        (m) => m.manage_profile_routes
      ),
    data: { title: "manage-profiles" },
  },
  {
    path: "notices-communications",
    loadChildren: () =>
      import(
        "./feature/notices-communications/module/notices-communications.routing.module"
      ).then((m) => m.notice_routes),
    data: { title: "notices_communications" },
  },
  {
    path: "car-sharing",
    loadChildren: () =>
      import("./feature/car-sharing/module/car-sharing.routing.module").then(
        (m) => m.car_sharing_routes
      ),
    data: { title: "car_sharing" },
  },
  {
    path: "support",
    loadChildren: () =>
      import("./feature/support/module/support.routing.module").then(
        (m) => m.support_routes
      ),
    data: { title: "support" },
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./feature/my-profile/module/my-profile-routing.module").then(
        (m) => m.myProfileRoutes
      ),
  },
  {
    path: "user",
    loadChildren: () =>
      import("./feature/user/module/user-routing.module").then((m) => m.user_routes),
  },
  {
    path: "hierarchy",
    loadChildren: () =>
      import("./feature/hierarchy/module/hierarchy.routing.module").then(
        (m) => m.hierarcy_routes
      ),
  },
  {
    path: "customer-service-management",
    loadChildren: () =>
      import(
        "./feature/customer-service-management/module/customer-service-management.routing.module"
      ).then((m) => m.customer_service_management_routes),
    data: { title: "customer-service-management" },
  },
];
const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: "enabled",
  // scrollPositionRestoration: "enabled",
};
export class AppRoutingModule { }
